import { render } from "./projectsecret.vue?vue&type=template&id=52c5dd14&ts=true"
import script from "./projectsecret.vue?vue&type=script&lang=ts"
export * from "./projectsecret.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__